// extracted by mini-css-extract-plugin
export default {"Block":"Block-module--Block--qor6b","Title":"Block-module--Title--8z96e"};